import * as Action from "./constants";
/**
 * create subscription
 */
export function createSubscription({ postData }) {
  return {
    type: Action.CREATE_SUBSCRIPTION,
    postData,
  };
}

export function getMaster() {
  return {
    type: Action.GET_MASTERS,
  };
}

export function getAllSubscription() {
  return {
    type: Action.GET_ALL_SUBSCRIPTION,
  };
}

// delete plan
export function deletePlan(id) {
  return {
    type: Action.DELETE_PLAN,
    id,
  };
}

// edit plan
export function editPlan(id) {
  return {
    type: Action.EDIT_PLAN,
    id,
  };
}

// update plan
export function updatePlan(postData) {
  return {
    type: Action.UPDATE_PLAN,
    postData,
  };
}

// update visibility status
export function updateVisibilityStatus(id) {
  return {
    type: Action.UPDATE_VISIBILITY_STATUS,
    id,
  };
}
